import { makeAutoObservable } from 'mobx'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import { toDecimal, pk } from '@dt/fe-utils'
import { cartMobx, productMobx, discountMobx, feeMobx } from '@mobx/mall'

// 将一个fkey还原成一个操作餐品doProduct
function restorePkToDoProduct (fkey: string, cnt: number = 1) {
  const [productNo, scaleNo, modifierGroupsPk] = fkey.split('_')
  // const productId = parseInt(productNo)
  // const scaleNo = parseInt(strScaleNo)
  const modifierGroups = []
  const viewProduct = productMobx.noToViewProductMap[productNo]
  if (!viewProduct) {
    console.error('the product is not exist')
    return
  }
  // 处理金额因为openPrice是一个可变金额所有需要另一个参数price
  if (viewProduct.isOpenPrice) {
    console.error('the product is a open price product, it not support')
    return
  }
  const scales = cloneDeep(viewProduct.scales)
  const doProduct = {
    type: viewProduct.type,
    no: viewProduct.no,
    name: viewProduct.name,
    pic: viewProduct.pic,
    cnt,
    scaleNo, // 默认选中第一个可售的规格
    isTogo: 0, // 当前暂时默认是false
    scales,
    modifierGroups,
    startTimeOffset: 0, // 当前默认startTimeOffset 0
    pk: pk()
  } as IMallDoProduct
  return doProduct
}

function getDefaultProduct () {
  return {
    type: 'mallProduct',
    id: 0,
    no: '',
    name: '',
    pic: '',
    cnt: 1,
    scales: [],
    modifierGroups: [],
    scaleNo: null,
    startTimeOffset: 0,
    isTogo: 0 as 0 | 1,
    introe: '',
    isScaleModifierGroup: false,
    itemPlan: null,
    taxCategoryId: 0,
    isTaxFree: false,
    allergys: [],
    tags: []
  }
}
/**
 * 操作餐品模块
 * 当一个餐品在放入购物车前的临时状态用此模块
 */
class DoProduct {
  constructor () {
    makeAutoObservable(this)
  }
  /** 餐品中基础数据，增加scales和modifierGroups作为变化中介质 */
  doProduct: IMallDoProduct = getDefaultProduct()
  /** 额外信息 */
  doProductExt: any = {}

  /** doProduct的计算结果，提供是否已经支持加入到购物车等判断结果 */
  get doProductResult () {
    let isReady = true
    let price = 0
    let actualPrice = 0
    let groupBuyPrice = 0
    if (this.doProduct.scaleNo) {
      const doScale = this.doProduct.scales.find((scale) => scale.no === this.doProduct.scaleNo)
      if (doScale) {
        // openPrice
        if (doScale.price === null) {
          isReady = false
        }
        price = doScale.price || 0
        actualPrice = doScale.actualPrice || 0
        groupBuyPrice = doScale.groupBuyPrice || 0
      }
    } else {
      const doScale = this.doProduct.scales[0]
      if (doScale) {
        // openPrice
        if (doScale.price === null) {
          isReady = false
        }
        price = doScale.price || 0
        actualPrice = doScale.actualPrice || 0
        groupBuyPrice = doScale.groupBuyPrice || 0
      }
    }
    const totalPrice = price
    const totalActualPrice = actualPrice
    const taxPrice = feeMobx.calTaxPrice(this.doProduct.taxCategoryId, totalActualPrice)
    return {
      price, // 餐品价
      isReady,
      groupBuyPrice, // 拼团价
      totalPrice, // 总价
      totalActualPrice, // 实际总价（按优惠价格计算）
      taxPrice
    }
  }

  /** 将一个餐品放入到可操作餐品中，之后可以在doProductMobx访问，具体会添加上可选择的属性 */
  pick ({ product, productNo, cartItem, cartItemPk, scaleNo, groupNo, groupBuyId, addPrice, isReturn }: { product?: IMallViewProduct; addPrice?: number; productNo?: string; cartItem?: IViewCartItem; cartItemPk?: string; scaleNo?: string; groupNo?: string; isReturn?: boolean; groupBuyId?: string }) {
    let doProduct: IMallDoProduct
    // 可能是一个餐品 也可能是一个购物车项
    if (productNo || product) {
      let viewProduct = product || (productNo ? productMobx.noToViewProductMap[productNo] : undefined)
      if (viewProduct) {
        // 将试图餐品变成操作餐品
        let scale: IMallScale
        // 来自于已经选中规格的餐品
        if (scaleNo) {
          scale = viewProduct.scales.find((scale) => scale.no === scaleNo) || viewProduct.scales.find((scale) => scale.saleCnt > 0 || scale.cnt > 0) || viewProduct.scales[0]
          if (!scale) {
            console.error('the select scale is soldout')
            return
          }
        } else {
          // TODO: 规格组内默认选中默认规则
          scale = viewProduct.scales.length >= 1 ? viewProduct.scales.find((scale) => scale.saleCnt > 0 || scale.cnt > 0) : viewProduct.scales[0]
        }
        const modifierGroups = []
        const scales = cloneDeep(viewProduct.scales).map((scale: IMallScale) => {
          // 对接营销价格
          if (scale.price) {
            if (discountMobx.itemDiscountMap && discountMobx.itemDiscountMap[viewProduct?.no + '_' + scale.no]) {
              scale.discountPrice = discountMobx.itemDiscountMap[viewProduct?.no + '_' + scale.no].off
              scale.actualPrice = toDecimal(scale.price - scale.discountPrice) as number
              scale.groupBuyPrice = discountMobx.itemDiscountMap[viewProduct?.no + '_' + scale.no].groupBuyPrice || 0
            } else {
              scale.discountPrice = 0
              scale.actualPrice = scale.price
            }
          }
          return scale
        })
        doProduct = {
          type: viewProduct.type,
          id: viewProduct.id,
          no: viewProduct.no,
          name: viewProduct.name,
          pic: viewProduct.pic,
          pics: viewProduct.pics,
          price: viewProduct.price,
          cnt: 1,
          addPrice,
          scaleNo: scale ? scale.no : null, // 默认选中第一个可售的规格
          isSingleScale: scale && scale.no === '0',
          scales,
          isTogo: cartMobx.cartResult.isTogo, // 来自购物车的默认togo状态
          isCanTogo: viewProduct.isCanTogo,
          startTimeOffset: 0,
          isOpenPrice: viewProduct.isOpenPrice,
          modifierGroups,
          allergys: viewProduct.allergys,
          tags: viewProduct.tags,
          intro: viewProduct.intro,
          saleCnt: scale ? scale.cnt : viewProduct.saleCnt,
          saleTotalCnt: viewProduct.saleTotalCnt,
          statSaleCnt: viewProduct.statSaleCnt,
          scaleGroupName: viewProduct.scaleGroup?.name || '',
          picBig: viewProduct.picBig,
          picWidth: viewProduct.picWidth,
          picHeight: viewProduct.picHeight,
          itemPlan: null,
          isScaleModifierGroup: viewProduct.scales.some(scale => !!scale.modifierGroups),
          taxCategoryId: viewProduct.taxCategoryId,
          isTaxFree: false
        } as IMallDoProduct
        if (groupNo) {
          doProduct.groupNo = groupNo
        }
        if (groupBuyId) {
          doProduct.groupBuyId = groupBuyId
        }
      }
    } else if (cartItemPk || cartItem) {
      let viewCartItem = cartItem || (cartItemPk ? cartMobx.pkToViewCartItemMap[cartItemPk] : undefined)
      if (viewCartItem) {
        let viewProduct = productMobx.noToViewProductMap[viewCartItem.productNo]
        if (product) {
          viewProduct = product
        }
        // 将试图餐品变成操作餐品
        let scale: IMallScale
        // 来自于已经选中规格的餐品
        if (scaleNo) {
          scale = viewProduct.scales.find((scale) => scale.no === scaleNo) || viewProduct.scales.find((scale) => scale.saleCnt > 0 || scale.cnt > 0) || viewProduct.scales[0]
          if (!scale) {
            console.error('the select scale is soldout')
            return
          }
        } else {
          // TODO: 规格组内默认选中默认规则
          scale = viewProduct.scales.length >= 1 ? viewProduct.scales.find((scale) => scale.saleCnt > 0 || scale.cnt > 0) : viewProduct.scales[0]
        }
        const modifierGroups = []
        // 将试图餐品变成操作餐品
        // const modifierGroups = convertFilterModifierGroupsTomodifierGroups(viewCartItem.modifierGroups, viewCartItem.productNo)
        const scales = cloneDeep(viewProduct.scales).map((scale: IScale) => {
          // 处理金额因为openPrice是一个可变金额所有需要另一个参数price
          if (scale.isOpenPrice) {
            scale.price = undefined
          } else {
            // 对接营销价格
            if (scale.price) {
              if (discountMobx.itemDiscountMap && discountMobx.itemDiscountMap[viewProduct.no + '_' + scale.no]) {
                scale.discountPrice = discountMobx.itemDiscountMap[viewProduct.no + '_' + scale.no].off
                scale.actualPrice = toDecimal(scale.price - scale.discountPrice) as number
              } else {
                scale.discountPrice = 0
                scale.actualPrice = scale.price
              }
            }
          }
          return scale
        })
        doProduct = {
          type: viewCartItem.type,
          no: viewCartItem.productNo,
          name: viewCartItem.name,
          pic: viewProduct.pic,
          pics: viewProduct.pics,
          cnt: viewCartItem.cnt,
          scaleNo: viewCartItem.scaleNo, // 默认选中第一个可售的规格
          isTogo: 0, // 来自购物车项的逆向
          isCanTogo: false,
          scales,
          addPrice,
          scaleGroupName: viewProduct.scaleGroup.name,
          modifierGroups,
          startTimeOffset: viewCartItem.startTimeOffset || 0,
          pk: viewCartItem.pk,
          intro: viewCartItem.intro,
          remark: viewCartItem.remark,
          isOpenPrice: viewProduct.isOpenPrice,
          picBig: viewProduct.picBig,
          picWidth: viewProduct.picWidth,
          picHeight: viewProduct.picHeight,
          allergys: viewProduct.allergys,
          saleCnt: scale ? scale.cnt : viewProduct.saleCnt,
          tags: viewProduct.tags,
          // TODO: 考虑存储的节点
          itemPlan: (discountMobx.discountAction.itemPlan && discountMobx.discountAction.itemPlan[viewCartItem.pk]) || null,
          isScaleModifierGroup: viewProduct.scales.some(scale => !!scale.modifierGroups),
          addUserId: viewCartItem.addUserId,
          addUserName: viewCartItem.addUserName,
          addUserAvatar: viewCartItem.addUserAvatar,
          taxCategoryId: viewProduct.taxCategoryId,
          isTaxFree: !!feeMobx.taxFreeAction[viewCartItem.pk],
          timestamp: viewCartItem.timestamp,
        }
        if (groupNo) {
          doProduct.groupNo = groupNo
        }
      }
    } else {
      doProduct = getDefaultProduct()
    }
    if (isReturn) {
      return doProduct
    }
    this.doProduct = doProduct
    this.pickExt()
  }

  pickExt (data?: {}) {
    this.doProductExt = data || {}
  }

  /** 重置doProduct */
  reset () {
    const cnt = this.doProduct.cnt
    if (this.doProduct.pk) {
      this.pick({ cartItemPk: this.doProduct.pk })
    } else {
      this.pick({ productNo: this.doProduct.no })
    }
    this.doProduct.cnt = cnt
  }

  /** 将一个pk还原成doProduct */
  restore (pk: string, cnt: number = 1) {
    const doProduct = restorePkToDoProduct(pk, cnt)
    if (doProduct) {
      this.doProduct = doProduct
    }
  }
  /** 选择规格 */
  selectScale (scaleNo: string) {
    const scale = this.doProduct.scales.find((scale) => scale.no === scaleNo)
    if (scale) {
      if (scale.saleCnt !== 0 || scale.cnt !== 0) {
        this.doProduct.scaleNo = scale.no
        this.doProduct.saleCnt = scale.cnt
      }
    }
  }

  /** 直接设置餐品数量 */
  setCnt (cnt: number) {
    // this.doProduct.cnt = cnt
    this.doProduct = {
      ...this.doProduct,
      cnt
    }
  }

  /** 设置餐品备注 */
  setRemark (remark: string) {
    this.doProduct.remark = remark
  }

  setTaxFee () {
    this.doProduct.isTaxFree = !this.doProduct.isTaxFree
  }
}
const doProduct = new DoProduct()
export { DoProduct, restorePkToDoProduct }
export default doProduct
